import { PRODUCT_TYPES } from '@schuettflix/interfaces';

export const PRODUCT_PLACEHOLDER_LABEL = {
    CUSTOM_BULK_MATERIAL: 'product.category.material',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'product.category.material',
    CUSTOM_CONCRETE: 'product.category.material',
    CUSTOM_ASPHALT: 'product.category.material',
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'product.category.material',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'product.category.material',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'product.category.material',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'product.category.material',
    // Transports
    CUSTOM_TRANSPORT: 'product.category.transport',
    // Material Services
    CUSTOM_SERVICE: 'product.category.custom',
    CUSTOM_SERVICE_ANALYSIS: 'product.category.custom',
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: 'product.category.custom',
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: 'product.service.customServiceTransport.placeholder',
    CUSTOM_SERVICE_TOLL: 'product.category.custom',
    CUSTOM_SERVICE_WAITING_TIME: 'product.category.custom',
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: 'product.category.material',
    RECYCLED_BULK_MATERIAL: 'product.category.material',
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'product.category.material',
    HAZARDOUS_WASTE_RECYCLING: 'product.category.material',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'product.category.material',
    NON_HAZARDOUS_WASTE_RECYCLING: 'product.category.material',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: 'product.category.transport',
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: 'product.category.custom',
    SERVICE_WEIGHING_NOTE: 'product.category.custom',
    SERVICE_ACCOMPANYING_DOCUMENT: 'product.category.custom',
    SERVICE_ENERGY_SURCHARGE: 'product.category.custom',
} as const satisfies Record<PRODUCT_TYPES, string>;
